module.exports = __webpack_public_path__ + "static/media/platform-1.cb60b07e.svg";